import packageJson from '../../../package.json'

const Health = () => (
  <div>
    healthy — v{packageJson.version}
  </div>
)

export default Health
